import React from "react";
import { Search } from "lucide-react";

/**
 * Botón visible en el sidebar que abre el GlobalSearch (Cmd/Ctrl+K).
 * El GlobalSearch escucha el evento custom `dnf:open-search`.
 */
export default function SidebarSearch() {
  return (
    <button
      type="button"
      data-testid="sidebar-search-btn"
      onClick={() => window.dispatchEvent(new CustomEvent("dnf:open-search"))}
      title="Buscar en la app (Ctrl/⌘+K)"
      className="w-full flex items-center gap-2 px-3 py-1.5 rounded-md bg-zinc-900/60 hover:bg-zinc-900 text-zinc-400 hover:text-zinc-200 text-xs transition-colors border border-zinc-800"
    >
      <Search className="w-3.5 h-3.5 shrink-0" />
      <span className="flex-1 text-left">Buscar…</span>
      <kbd className="bg-zinc-950 border border-zinc-700 rounded px-1.5 text-[9px] text-zinc-500 font-mono">⌘K</kbd>
    </button>
  );
}
